// Tiny inline sparkline for the right edge of a Buy-feed list row. Extracted
// from the old BuyScreen (which A4 deletes) into a shared component so the
// unified feed (A1) and any future row surface can reuse it without copying
// the chart wiring. Same chart library as ItemPriceChart so we don't pick up a
// new dep — just stripped of axes / labels / interaction. Width/height tuned to
// slot between the card body and the chevron without crowding either.

import React from 'react';
import { LineChart } from 'react-native-svg-charts';
import * as shape from 'd3-shape';

interface Props {
  data: number[];
  color: string;
}

export default function MiniSparkline({ data, color }: Props) {
  // A single point can't draw a line; render nothing rather than a dot/crash.
  if (data.length < 2) return null;
  return (
    <LineChart
      style={{ width: 56, height: 28 }}
      data={data}
      svg={{ stroke: color, strokeWidth: 1.5 }}
      contentInset={{ top: 4, bottom: 4, left: 0, right: 0 }}
      curve={shape.curveMonotoneX}
    />
  );
}
